import React from 'react'
import { useListboxContext } from '@reach/listbox'

import { Option, RadioButton } from './AccessLevelSelect.styles'
import type { LevelSelectorProps } from './types'

const LevelOption: React.FC<LevelSelectorProps> = props => {
  const {
    disabled,
    'data-testid': dataTestId,
    label,
    help,
    level,
    negative,
  } = props
  const { value } = useListboxContext()

  return (
    <Option
      data-testid={dataTestId}
      name="AccessLevelOption"
      value={level}
      label={label}
      disabled={disabled}
      $negative={negative}
    >
      <RadioButton
        name="access-level"
        help={help}
        label={label}
        checked={level === value}
        onChange={() => {}}
        disabled={disabled}
        negative={negative}
      />
    </Option>
  )
}

export default LevelOption
